/**
 * 语言 —— Master Spec §2 规定的三种界面语言，BCP-47 代码。
 * 任何时刻界面只显示一种语言；三语并列显示是明确禁止的。
 */
export const SUPPORTED_LOCALES = ['zh-Hans', 'es', 'en'];
export const DEFAULT_LOCALE = 'en';
/** 登录页语言选择器的原生名称（这三个字符串本身不翻译） */
export const LOCALE_NATIVE_NAMES = {
    'zh-Hans': '中文',
    es: 'Español',
    en: 'English',
};
export function isLocale(value) {
    return typeof value === 'string' && SUPPORTED_LOCALES.includes(value);
}
/** 从 Accept-Language 头解析出最合适的受支持语言 */
export function negotiateLocale(acceptLanguage) {
    if (!acceptLanguage)
        return DEFAULT_LOCALE;
    const tags = acceptLanguage
        .split(',')
        .map((part) => {
        const [tag = '', q = 'q=1'] = part.trim().split(';');
        return { tag: tag.toLowerCase(), q: Number.parseFloat(q.replace('q=', '')) || 0 };
    })
        .sort((a, b) => b.q - a.q);
    for (const { tag } of tags) {
        if (tag.startsWith('zh'))
            return 'zh-Hans';
        if (tag.startsWith('es'))
            return 'es';
        if (tag.startsWith('en'))
            return 'en';
    }
    return DEFAULT_LOCALE;
}
//# sourceMappingURL=locale.js.map